<template>
  <div>
    <h2>Информация о социальном проекте Demis Group</h2>

    <p>
      <span class="text-bold">Ежегодно в России</span>, согласно официальным данным, <span class="text-bold">от последствий курения погибает более 400 000 человек</span>, вдобавок к этому, <span class="text-bold">качество жизни десятков миллионов людей</span> из-за курения <span class="text-bold">является крайне низким (различные острые и хронические болезни, преждевременное старение, отсутствие энергии и т.д.).</span>
    </p>

    <p><span class="text-bold">Сегодня мы – одна из самых курящих стран в мире</span>, со всеми вытекающими последствиями.</p>

    <p>Руководство нашей страны начало заниматься этой проблемой, но, к сожалению, оно пока не предоставляет курильщикам информацию о действенном способе для успешного и простого отказа от курения.</p>

    <p>В то же время, <span class="text-bold">уже более 30 лет существует метод</span>, который <span class="text-bold">помог с легкостью бросить курить более чем <br> 25 000 000 человек по всему миру</span>. Это метод <span class="text-bold">Аллена Карра "Легкий способ бросить курить"</span>. Несмотря на <span class="text-bold">высочайшую результативность (95% при правильном применении!)</span>, информацию об этом методе сложно встретить в крупнейших СМИ, что объясняется активными действиями табачного лобби. Чаще всего люди узнают об этом методе из уст в уста, с помощью сарафанного радио.</p>

    <p><span class="text-bold">Цель нашего проекта xsmoker.ru  - помочь максимальному количеству курильщиков в России и СНГ с легкостью бросить курить, рассказав им о методе Аллена Карра и о его правильном применении.</span></p>

    <p>Мы с уверенностью говорим об эффективности этого метода в частности потому, что <span class="text-bold">многие сотрудники нашей группы компаний уже бросили курить этим способом</span>, действительно легко и с удовольствием.</p>

    <p>Естественно, речь идет только о добровольном отказе от курения, мы считаем, что у компании нет морального права навязывать подобные решения, мы можем лишь рассказать об имеющихся возможностях.</p>

    <p>Отличительной особенностью этого метода является то, что <span class="text-bold">его можно применить практически бесплатно и очень быстро</span>, достаточно просто внимательно и не спеша (за 3-5 дней) <span class="text-bold">прочитать книгу Аллена Карра</span>, которая развеивает все мифы о курении и объясняет механизм зависимости, – тогда <span class="text-bold">желание курить уйдет само, без каких-либо неприятных последствий в виде набора веса, необоснованной раздражительности</span> и прочих. Вместо этого значительно <span class="text-bold">увеличится энергия и настроение, в разы улучшится здоровье и появится чувство свободы!</span></p>

    <p>Проект по освобождению от никотиновой зависимости реализован в рамках социальной ответственности компании Demis Group (www.demis.ru) , одной из ведущих российских компаний в сфере интернет-маркетинга.</p>

    <p>На сегодняшний день мы, вместе со своими партнерами, уже рассказали об этом методе более чем 500 000 человек. Посещаемость сайтов стремительно растёт, а наш проект в социальных сетях под названием “Бросил. Не курю!” набирает обороты. </p>

    В своей работе мы используем как онлайн, так и оффлайн-средства распространения информации.

    <h3>Как Вы можете быстро и легко помочь огромному количеству людей?</h3>

    <p>Ниже представлено несколько стандартных вариантов сотрудничества с нами, с целью популяризации методики А. Карра, на запуск которых Вам потребуется не более 15 минут(!).</p>

    <ol>
      <li>
        <p>Вы можете разместить один из наших баннеров на своем сайте.</p>

        <p class="text-center">
          <img
            src="../../../img/faq/stopsmoking/banner1.jpg"
            alt="banner"
          >
        </p>
        <div class="link-box">
          &lt;a href="http://xsmoker.ru/how_to_stop/"&gt;&lt;img src="http://xsmoker.ru/upload/medialibrary/681/6814545e395ce43b4a7410bea75b2e8e.jpg"/&gt;&lt;/a&gt;
        </div>
        <p />
        <p class="text-center">
          <img
            src="../../../img/faq/stopsmoking/banner2.jpg"
            alt="banner2"
          >
        </p>
        <div class="link-box">
          &lt;a href="http://xsmoker.ru/how_to_stop/"&gt;&lt;img src="http://xsmoker.ru/upload/medialibrary/b11/b11fbc390682a3598dad4c1a8a6a6d7e.jpg"/&gt;&lt;/a&gt;
        </div>
        <p />
        <p class="text-center">
          <img
            src="../../../img/faq/stopsmoking/banner3.jpg"
            alt="banner3"
          >
        </p>
        <div class="link-box">
          &lt;a href="http://xsmoker.ru/how_to_stop/"&gt;&lt;img src="http://xsmoker.ru/upload/medialibrary/3a8/3a8c0c3b034743c74d341e77f83e26ce.jpg"/&gt;&lt;/a&gt;
        </div>
        <p />
        <p>Таким образом, Вы поможете большому количеству людей узнать о простом методе освобождения от никотиновой зависимости. Ниже приложены наши баннеры и ссылки на размещение.</p>
      </li>

      <li>
        <p>Брошюры для Вашего офиса.</p>
        <p>
          Вы можете заказать наши брошюры (<a
            href="#"
            data-toggle="modal"
            :data-target="'#' + bookletExampleModalId"
          >посмотреть дизайн</a>) для распространения в своем офисе (на ресепшене, в переговорных комнатах, курилках, столовых).
          Эти брошюры лаконично рассказывают об эффективном методе отказа от сигарет.
          Мы бесплатно привезем их к Вам в офис в течение 2-х рабочих дней.
        </p>
        <div class="text-center">
          <!-- TODO: у этой кнопки еще нет обработчика -->
          <button class="btn background-white border-danger text-danger">
            Заказать
          </button>
        </div>
      </li>

      <li>
        <p>Материалы для Вашего издания.</p>
        <p>Если у вас есть информационный портал или печатное издание, мы готовы подготовить для вас статьи на тему освобождения от никотиновой зависимости. За время работы мы собрали большую статистику по курению в целом по России, провели несколько исследований в рамках своей компании на тему эффективности работников до и после отказа от курения, наработали большую базу контактов в сфере борьбы с курением.</p>
      </li>
    </ol>

    <p>При любом из вариантов сотрудничества мы дарим Вашей компании набор книг Аллена Карра и сувенирную продукцию проекта «Бросил. Не курю!», а также размещаем баннер Вашей компании на нашем сайте в разделе Партнеры.</p>

    <p class="text-right">
      Ольга Борисова, <br>
      руководитель отдела социальных проектов Demis Group<br>
      тел. +7 (903) 274-26-87<br>
      тел. +7 (495) 223-66-59<br>
      Email: onb@demis.ru<br>
    </p>

    <c-modal
      :id="bookletExampleModalId"
      :padding="0"
      overflow="hidden"
    >
      <div
        id="carousel-booklet-example"
        class="carousel slide"
        data-ride="carousel"
      >
        <ol class="carousel-indicators">
          <li
            data-target="#carousel-booklet-example"
            data-slide-to="0"
            class="active"
          />
          <li
            data-target="#carousel-booklet-example"
            data-slide-to="1"
          />
        </ol>

        <div
          class="carousel-inner"
          role="listbox"
        >
          <div class="item active">
            <img
              src="../../../img/faq/stopsmoking/booklet-example-1.jpg"
              alt="Booklet 1"
            >
            <div class="carousel-caption">
              Пример 1
            </div>
          </div>
          <div class="item">
            <img
              src="../../../img/faq/stopsmoking/booklet-example-2.jpg"
              alt="Booklet 2"
            >
            <div class="carousel-caption">
              Пример 2
            </div>
          </div>
        </div>

        <a
          class="left carousel-control"
          href="#carousel-booklet-example"
          role="button"
          data-slide="prev"
        >
          <span
            class="glyphicon glyphicon-chevron-left"
            aria-hidden="true"
          />
          <span class="sr-only">Предыдущий</span>
        </a>
        <a
          class="right carousel-control"
          href="#carousel-booklet-example"
          role="button"
          data-slide="next"
        >
          <span
            class="glyphicon glyphicon-chevron-right"
            aria-hidden="true"
          />
          <span class="sr-only">Следующий</span>
        </a>
      </div>
    </c-modal>
  </div>
</template>

<script>
import CModal from '../../components/ui/CModal'

export default {
  name: 'StopSmoking',
  components: { CModal },
  data () {
    return {
      bookletExampleModalId: 'BOOKLET_EXAMPLE_MODAL_ID'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.link-box {
  padding: 5px;
  max-width: 892px;
  margin: auto;
  border: 1px solid #3db513;
  text-align: center;
  word-break: break-all;
}

img {
  max-width: 100%;
}
</style>
